import styled, { css } from 'styled-components'
import recordIcon from 'static/images/icons/icon_record_video.svg'
import recordIconHover from 'static/images/icons/icon_record_video_hover.svg'
import recordIconDisabled from 'static/images/icons/icon_record_video_disabled.svg'

export const RecordButtonStyled = styled.button`
  display: block;
  background: url(${recordIcon}) no-repeat;
  background-size: contain;
  width: 24px;
  height: 14px;
  cursor: pointer;
  border: none;

  &:hover {
    background: url(${recordIconHover}) no-repeat;
    background-size: contain;
  }

  && {
    ${props =>
      props.disabled &&
      css`
        background: url(${recordIconDisabled}) no-repeat;
        background-size: contain;
        cursor: not-allowed;
      `}
  }
`

export const EmbeddedVideoWrapper = styled.div`
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  margin: 10px 0;
`

export const EmbeddedVideoStyled = styled.iframe`
  border: 0px;
  width: 100%;
  height: 100%;
`

export const videoSizes = {
  small: {
    maxWidth: 280,
    maxHeight: 160
  },
  medium: {
    maxWidth: 400,
    maxHeight: 250
  },
  large: {
    maxWidth: 600,
    maxHeight: 350
  },
  minRatio: 0.75,
  maxRatio: 3
}
